import { onMount } from 'solid-js'
import { PerspectiveCamera, type Camera } from 'three'
import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js'
import createDepthColorEffectShader from './createDepthColorEffectShader'

export default function createMountedDepthColorEffectShader(
  composer: EffectComposer,
  camera: Camera,
  // renderTarget: WebGLRenderTarget,
) {
  const depthColorEffect = new ShaderPass(createDepthColorEffectShader())
  // You MUST provide the depth texture to this shader
  // The correct depth texture is usually from the composer's read buffer
  // or the main render target if this is the first pass using depth.
  // This needs to be updated each frame if the readBuffer changes.

  // Set camera uniforms (can be done once if camera doesn't change near/far planes)
  if (camera instanceof PerspectiveCamera) {
    depthColorEffect.uniforms.cameraNear.value = camera.near
    depthColorEffect.uniforms.cameraFar.value = camera.far
  }

  composer.addPass(depthColorEffect)

  // createMountedInverval(() => {
  //   depthColorEffect.enabled = !depthColorEffect.enabled
  //   console.log('[DepthColorEffect]', 'enabled', depthColorEffect.enabled)
  //   // depthColorEffect.enabled = false
  // }, 1500)

  // depthColorEffect.enabled = false

  onMount(() => {
    const last = composer.passes.at(-1)
    if (last) {
      last.renderToScreen = true
    }
    depthColorEffect.uniforms.tDepth.value = composer.readBuffer.depthTexture
  })

  return depthColorEffect
}
